(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('usersPerVisitReportController', usersPerVisitReportController);

  /** @ngInject */
  function usersPerVisitReportController($scope, $translate, reportExportUtil, exportToCsv, UsersPerVisitReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new UsersPerVisitReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init() {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy() {
      vm.report.destroy();
    }

    function exportCsv() {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant('NUMBER_OF_VISITS_TITLE'),
        vm.report.chart.data,
        reportExportUtil.ValueFormattersEnum.DEFAULT,
        reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
        $translate.instant('VISITS_COUNT_REPORT'),
        true);
    }

  }
})();
